<template>
  <div class="d-flex flex-column">
      <v-card class="mt-5 mb-5">

          <v-card-title
              class="text_primary"
         >
            {{ `組織` }}

            <v-spacer></v-spacer>
            <v-btn
                v-if="!is_edit_name"
                class="text_default btn_default btn_default_bg_linear"
                outlined
                @click="startEditName"
            >
                編輯
            </v-btn>

            <v-btn
                v-if="is_edit_name"
                class="text_default btn_default btn_default_bg_linear mr-3"
                outlined
                @click="cancelEditName"
            >
                取消
            </v-btn>

            <v-btn
                v-if="is_edit_name"
                class="btn-primary"
                outlined
                @click="saveEditName"
            >
                保存
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>
          
          <v-card-text>
            <v-row>
              <v-col
                lg="4"
                md="4"
                xs="12"
                class="pt-0 pb-2"
              >
                <h5 class="mb-0 pb-0  text-subtitle-1">名稱: </h5>
                <v-text-field
                  v-if="is_edit_name"
                  v-model="info.org_name"
                  :rules="[$utils.field_rules.required]"
                  outlined
                  height="12"
                  dense
                  validate-on-blur
                  hide-details
                ></v-text-field>

                <h6 v-else class="mb-0 pb-0 text-subtitle-2">{{info.org_name}}</h6>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                lg="4"
                md="4"
                xs="12"
                class="pt-0 pb-2"
              >
                <h5 class="mb-0 pb-0  text-subtitle-1">店長: </h5>
                <h6 class="mb-0 pb-0 text-subtitle-2">{{info.user_name}}</h6>
              </v-col>
            </v-row>

            <v-row
              class="pa-0"
            >
              <v-col
                lg="4"
                md="4"
                xs="12"
                class="pt-0 pb-2"
              >
                <h5 class="mb-0 pb-0  text-subtitle-1">電郵: </h5>
                <h6 class="mb-0 pb-0 text-subtitle-2">{{info.email}}</h6>
              </v-col>
            </v-row>
          </v-card-text>

      </v-card>
  </div>
    
</template>

<script>
import {
  apiGetOrganizeInfo,
  apiRenameOrganization
} from '@/api/organize.js'

  export default {
    name: 'Organize',
    components: {
    },
    data: function(){
      return {
        is_edit_name: false,
        info: {},
        tmp_info: null
      }
    }, 
    created: async function(){
      await this.getData()
    },
    mounted: function(){

    },
    methods: {
      async getData(){
        try {
          let result = await apiGetOrganizeInfo(
            this.$route.params.org_id
          )
          this.info = result
          console.log('result', result)
        } catch (error) {
          this.$root.vtoast.show({
            message: `刪除設定檔失敗，原因: ${error}` 
          })
        }
      },
      startEditName(){
        this.is_edit_name = true
        this.tmp_info = JSON.parse(JSON.stringify(this.info))
      },
      cancelEditName(){
        this.is_edit_name = false
        this.info = JSON.parse(JSON.stringify(this.tmp_info))
      },
      async saveEditName(){
        let params = {
          name: this.info.org_name
        }
        try {
          let result = await apiRenameOrganization(
            this.$route.params.org_id, params
          )
          console.log('result', result)
          this.$root.vtoast.show({
            color: 'primary',
            message: `更新名稱成功！` 
          })
          setTimeout(() => {
            this.$router.go()
          },200)
          
        } catch (error) {
          this.$root.vtoast.show({
            message: `更新名稱失敗，原因: ${error}` 
          })
        }

        this.is_edit_name = false
      }
    },
    watch: {
    },
    computed: {
    }     
  }
</script>
<style scoped>
  h4 {
      color: #5b5b5b;
  }
</style>